import React, { useEffect, useState } from 'react';
import { Button, message } from 'antd';
import { StarFilled, StarOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { favoritePost, unfavoritePost } from '@/apis/posts';
import { syncPostMetrics } from '@/store/modules/posts';
import usePrivateAction from '@/utils/usePrivateAction';

const FavoriteButton = ({ post, onChange }) => {
  const { isAuthenticated, userInfo, sessionVersion } = useSelector(state => state.user);
  const [selected, setSelected] = useState(isAuthenticated && Boolean(post.is_favorited));
  const { busy, run } = usePrivateAction(); const dispatch = useDispatch(); const navigate = useNavigate();
  useEffect(() => { setSelected(isAuthenticated && Boolean(post.is_favorited)); }, [post.id, post.is_favorited, isAuthenticated, userInfo?.id, sessionVersion]);
  return <Button className="post-favorite-button" type={selected ? 'primary' : 'default'}
    icon={selected ? <StarFilled /> : <StarOutlined />} aria-pressed={selected} loading={busy} disabled={busy} onClick={() => {
    if (!isAuthenticated) { message.warning('请先登录后收藏'); navigate('/login'); return; }
    run(() => selected ? unfavoritePost(post.id) : favoritePost(post.id), () => {
      const value = !selected; setSelected(value); onChange?.(value);
      dispatch(syncPostMetrics({ postId: post.id, is_favorited: value }));
      message.success(value ? '已收藏帖子' : '已取消收藏');
    }, '收藏操作失败，请重试');
  }}>{selected ? '已收藏' : '收藏'}</Button>;
};
export default FavoriteButton;
